module.exports = __webpack_public_path__ + "static/media/decisions-wait-for-sales.a03c7945.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/decisions-wait-for-sales.png
// module id = 2572
// module chunks = 0